import { SET_FNA_VALUE } from '../actions'

export const SET_FNA_NEED_CATEGORY = 'SET_FNA_NEED_CATEGORY'
export const setSelectedNeedId = (id, planId) => {
  return {
    type: SET_FNA_NEED_CATEGORY,
    payload: {
      id,
      planId,
    },
  }
}

export const CLEAR_FNA_NEED_GAP_QUESTIONS = 'CLEAR_FNA_NEED_GAP_QUESTIONS'
export const clearFnaNeedGapQuestions = () => {
  return {
    type: CLEAR_FNA_NEED_GAP_QUESTIONS,
  }
}

export const SET_FNA_GAP_VALUE = 'SET_FNA_GAP_VALUE'
export const setFnaGapValue = (questionKey, value) => {
  return {
    type: SET_FNA_GAP_VALUE,
    payload: {
      questionKey,
      value,
    },
  }
}

export const SET_FNA_GAP_TARGET_SAVINGS = 'SET_FNA_GAP_TARGET_SAVINGS'
export const setFnaGapTargetSavings = (value) => {
  return {
    type: SET_FNA_GAP_TARGET_SAVINGS,
    payload: value,
  }
}

export const CLEAR_FNA_GAP_TARGET_SAVINGS = 'CLEAR_FNA_GAP_TARGET_SAVINGS'
export const clearFnaGapTargetSavings = () => {
  return {
    type: CLEAR_FNA_GAP_TARGET_SAVINGS,
  }
}

export const CLEAR_FNA_GAP_INVESTMENT_GOAL_OTHER = 'CLEAR_FNA_GAP_INVESTMENT_GOAL_OTHER'
export const clearFnaGapInvestmentGoalOther = () => {
  return {
    type: CLEAR_FNA_GAP_INVESTMENT_GOAL_OTHER,
  }
}

export const CLEAR_REASON_FOR_CHOOSING_OTHER = 'CLEAR_REASON_FOR_CHOOSING_OTHER'
export const clearReasonForChoosingOther = () => {
  return {
    type: CLEAR_REASON_FOR_CHOOSING_OTHER,
  }
}

export const CLEAR_OTHER_COVERAGE_OTHER = 'CLEAR_OTHER_COVERAGE_OTHER'
export const clearOtherCoverageOther = () => {
  return {
    type: CLEAR_OTHER_COVERAGE_OTHER,
  }
}

export const setNeedGapValue = (path, value) => ({
  type: SET_FNA_VALUE,
  payload: {
    path: 'needGap.' + path,
    value: value,
  },
})

export const setQuestion = (questionKey, value) => setNeedGapValue(`questions.${questionKey}`, value)

export const RESET_FNA_NEED = 'RESET_FNA_NEED'

export const resetFNA = () => ({
  type: RESET_FNA_NEED,
})
